import { i18n } from '@lingui/core';
import { Trans } from '@lingui/react';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import Grid from '@mui/material/Grid2';
import { ClassNameMap } from '@mui/styles';
import Actions from 'components/Actions';

interface FormActionsProps {
  isUpdate: boolean;
  isSubmitting: boolean;
  isValid: boolean;
  isOptimised: boolean;
  dirty: boolean;
  resetForm: () => void;
  onCancel: () => void;
  classes: ClassNameMap;
}

const FormActions = ({ isUpdate, isSubmitting, isValid, isOptimised, dirty, resetForm, onCancel, classes }: FormActionsProps) => (
  <Grid container spacing={0}>
    <Grid size={12}>
      <Divider className={classes.fullWidthDivider} />
    </Grid>

    <Grid size={12}>
      <Actions
        left={[
          ['cancel', (
            <Button variant="contained" color="secondary" onClick={() => onCancel()}>
              <Trans id="Cancel">Cancel</Trans>
            </Button>
          )],
        ]}
        right={[
          ['reset', (
            <Button variant="contained" color="secondary" onClick={resetForm}>
              <Trans id="Reset">Reset</Trans>
            </Button>
          )],
          [i18n._('submit'), (
            <Button variant="contained" color="secondary" type="submit" disabled={isSubmitting || !isValid || !dirty || !isOptimised}>
              {isUpdate ? <Trans id="Update">Update</Trans> : <Trans id="Create">Create</Trans>}
            </Button>
          )],
        ]}
      />
    </Grid>
  </Grid>
);

export default FormActions;
